export default __webpack_public_path__ + "static/media/BasicPublic2.83b1a03c.png";